import { render, staticRenderFns } from "./TransactionsTemplatesList.vue?vue&type=template&id=fc7ca27c&"
import script from "./TransactionsTemplatesList.vue?vue&type=script&lang=js&"
export * from "./TransactionsTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports